import React, { createContext, useContext, useMemo } from 'react';

// Per-admin permissions, as handed back by GET /api/account/me.
//
// A Super Admin passes every check without consulting the map — that mirrors
// the server, where a superadmin is answered from the catalog and can never be
// locked out by what happens to be stored. A plain Admin sees exactly the
// screens a Super Admin has switched on in Manage Admins.
//
// Hiding a control here is only half of it: every one of these is enforced
// again on its route in GolpoServer (see config/permissions.js). This is so the
// panel doesn't offer a button that would come back 403.
//
// The keys below are only the ones the panel actually gates on. The labels and
// grouping shown in the Manage Admins editor come from the server's catalog
// endpoint, so there is no second list to keep in step.
export const PERM = {
  CREATE_RESELLER: 'createReseller',
  CREATE_AGENCY: 'createAgency',
  VIEW_RESELLERS: 'viewResellers',
  DELETE_ACCOUNTS: 'deleteAccounts',
  VIEW_BALANCES: 'viewBalances',
  EDIT_BALANCE: 'editBalance',
  EDIT_GOLD: 'editGold',
  VIEW_BILL: 'viewBill',
  SET_MODERATOR: 'setModerator',
  MANAGE_GIFTS: 'manageGifts',
  MANAGE_STORE: 'manageStore',
  MANAGE_BANNERS: 'manageBanners',
  MANAGE_GAMES: 'manageGames',
};

const PermissionContext = createContext(null);

export const PermissionProvider = ({ role, permissions, children }) => {
  const can = useMemo(() => {
    if (role === 'superadmin') return () => true;
    const map = permissions || {};
    return (key) => map[key] === true;
  }, [role, permissions]);

  return <PermissionContext.Provider value={can}>{children}</PermissionContext.Provider>;
};

// const can = useCan();  →  can(PERM.VIEW_BILL)
// Defaults to denying everything, so a component rendered outside the provider
// fails closed rather than showing controls it shouldn't.
export function useCan() {
  return useContext(PermissionContext) || (() => false);
}
